var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 4.7C7.4 6.19117 6.19117 7.4 4.7 7.4C3.20883 7.4 2 6.19117 2 4.7C2 3.20883 3.20883 2 4.7 2C6.19117 2 7.4 3.20883 7.4 4.7Z",
    stroke: "#870091",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 4.7C20.0001 6.19117 18.7913 7.4 17.3001 7.4C15.8089 7.4 14.6001 6.19117 14.6001 4.7C14.6001 3.20883 15.8089 2 17.3001 2C18.7913 2 20.0001 3.20883 20.0001 4.7Z",
    stroke: "#870091",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 17.3001C7.4 18.7913 6.19117 20.0001 4.7 20.0001C3.20883 20.0001 2 18.7913 2 17.3001C2 15.8089 3.20883 14.6001 4.7 14.6001C6.19117 14.6001 7.4 15.8089 7.4 17.3001Z",
    stroke: "#870091",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 17.3001C20.0001 18.7913 18.7913 20.0001 17.3001 20.0001C15.8089 20.0001 14.6001 18.7913 14.6001 17.3001C14.6001 15.8089 15.8089 14.6001 17.3001 14.6001C18.7913 14.6001 20.0001 15.8089 20.0001 17.3001Z",
    stroke: "#870091",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 17.2998H14.5999",
    stroke: "#870091",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 4.7002H14.5999",
    stroke: "#870091",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 14.6001L17.2998 7.4001",
    stroke: "#870091",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7002 14.6001L4.70019 7.4001",
    stroke: "#870091",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.a3bb91014bded9951a50b5f391685b90.svg";
export { ForwardRef as ReactComponent };